import { comparePublicationIssues, type IssueOrderFields } from "../issue-order";

export type PublicationThemeKey =
  | "caixin"
  | "businessweek"
  | "science"
  | "economist"
  | "barrons"
  | "default";

export type PublicationTheme = {
  key: PublicationThemeKey;
  label: string;
  shortLabel: string;
  accent: string;
  surface: string;
  inkOnAccent: string;
};

const THEMES: Record<PublicationThemeKey, PublicationTheme> = {
  caixin: {
    key: "caixin",
    label: "财新周刊",
    shortLabel: "财新",
    accent: "#a52b22",
    surface: "#ddd4c6",
    inkOnAccent: "#ffffff",
  },
  businessweek: {
    key: "businessweek",
    label: "彭博商业周刊",
    shortLabel: "彭博",
    accent: "#f0e832",
    surface: "#15191f",
    inkOnAccent: "#161a20",
  },
  science: {
    key: "science",
    label: "科学",
    shortLabel: "SCIENCE",
    accent: "#b31f2b",
    surface: "#13283d",
    inkOnAccent: "#ffffff",
  },
  economist: {
    key: "economist",
    label: "经济学人",
    shortLabel: "The Economist",
    accent: "#e3120b",
    surface: "#f4f0e7",
    inkOnAccent: "#ffffff",
  },
  barrons: {
    key: "barrons",
    label: "巴伦周刊",
    shortLabel: "BARRON'S",
    accent: "#17365d",
    surface: "#f2efe7",
    inkOnAccent: "#ffffff",
  },
  default: {
    key: "default",
    label: "期刊",
    shortLabel: "期刊",
    accent: "#776f63",
    surface: "#ddd4c6",
    inkOnAccent: "#ffffff",
  },
};

export function publicationTheme(publication: string): PublicationTheme {
  const normalized = publication.trim().toLocaleLowerCase();
  if (normalized.includes("财新") || normalized === "caixin") return THEMES.caixin;
  if (
    normalized.includes("彭博商业周刊")
    || normalized.includes("bloomberg businessweek")
    || normalized === "businessweek"
  ) {
    return THEMES.businessweek;
  }
  if (normalized === "科学" || normalized === "science") return THEMES.science;
  if (normalized === "经济学人" || normalized === "the economist") {
    return THEMES.economist;
  }
  if (
    normalized === "巴伦周刊"
    || normalized === "barron's"
    || normalized === "barrons"
  ) {
    return THEMES.barrons;
  }
  return THEMES.default;
}

export function newestIssueIds(
  issues: ReadonlyArray<IssueOrderFields>,
): Set<string> {
  const newest = new Map<string, IssueOrderFields>();
  for (const issue of issues) {
    const themeKey = publicationTheme(issue.publication).key;
    const key = themeKey === "default" ? issue.publication : themeKey;
    const current = newest.get(key);
    if (!current || comparePublicationIssues(issue, current) < 0) newest.set(key, issue);
  }
  return new Set([...newest.values()].map((issue) => issue.id));
}
